import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import ClickOutside from '../ClickOutside';
import './ButtonToMenu.scss';

const FIRST_RENDER_DELAY = 150;

const ButtonToMenu = ({ closeComponent, openComponent, transition = 300, showShadow = false }) => {
	const refAnimate = useRef(null);

	const [openMenu, setOpenMenu] = useState(true);
	const [expand, setExpand] = useState(false);
	const [height, setHeight] = useState(false);
	const [width, setWidth] = useState(false);

	const [smallWidth, setSmallWidth] = useState(null);
	const [smallHeight, setSmallHeight] = useState(null);
	const [bigWidth, setBigWidth] = useState(null);
	const [bigHeight, setBigHeight] = useState(null);
	const [firstRender, setFirstRender] = useState(true);

	useEffect(() => {
		if (expand) {
			setOpenMenu(true);

			setHeight(bigHeight);
			setWidth(bigWidth);
		} else {
			setTimeout(() => {
				setOpenMenu(false);
			}, transition);

			setHeight(smallHeight);
			setWidth(smallWidth);
		}
	}, [expand]);

	useEffect(() => {
		const appOverlay = document.querySelector('.ButtonToMenu-overlay');

		if (!appOverlay) return;

		if (expand) {
			appOverlay.classList.add('open');
		} else {
			appOverlay.classList.remove('open');
		}

		return () => appOverlay.classList.remove('open');
	}, [expand]);

	useEffect(() => {
		let obj = refAnimate.current?.getBoundingClientRect();

		if (!obj) return;

		if (firstRender) {
			setBigHeight(obj.height);
			setBigWidth(obj.width);

			setOpenMenu(false);
			setFirstRender(false);
		} else {
			setTimeout(() => {
				obj = refAnimate.current?.getBoundingClientRect();

				setSmallHeight(obj?.height);
				setSmallWidth(obj?.width);

				setHeight(obj?.height);
				setWidth(obj?.width);
			}, transition + FIRST_RENDER_DELAY);
		}
	}, [firstRender]);

	return (
		<ClickOutside
			onClickOutside={() => {
				setExpand(false);
			}}
		>
			<div
				ref={refAnimate}
				style={{ height: height, width: width, transition: transition + 'ms' }}
				className={classNames('ButtonToMenu', {
					open: openMenu,
					close: !openMenu,
					first: firstRender,
					shadow: showShadow,
				})}
			>
				{!openMenu ? (
					<div
						key='close'
						className='ButtonToMenu-close fadeIn'
						style={{ animationDuration: transition + 'ms' }}
						onClick={() => {
							setExpand(true);
						}}
					>
						{closeComponent({ expand, setExpand })}
					</div>
				) : (
					<div key='open' className={expand ? 'fadeIn' : 'fadeOut'} style={{ animationDuration: transition + 'ms' }}>
						{openComponent({ expand, setExpand })}
					</div>
				)}
			</div>
		</ClickOutside>
	);
};

ButtonToMenu.propTypes = {
	closeComponent: PropTypes.func,
	openComponent: PropTypes.func,
	transition: PropTypes.number,
	isShadow: PropTypes.bool,
};

export default ButtonToMenu;
